<template>
  <div>
    <breadcrumb :breadcrumbs="breadcrumbs" />
    <header-banner title="デモ機貸出し方法" />
    <div class="news-contents">
      <div class="content">
        <content-header title="デモ機無料レンタル受付中！" />
        <div class="content-body">
          <div class="content-subtitle">レンタル費0円 設置工事不要！</div>
          「電波が届くのか心配」「購入前に試してみたい」など、ご購入に不安がある方は<br />
          実際にご使用いただく場所で、商品の動作や使い勝手などを十分にお試しください。<br />
          <br />

          <div class="content-subtitle">■ デモ機貸出し条件</div>
          ・貸出し期間はデモ機の到着から1週間となります。<br />
          ・在庫状況により貸出し開始までお待ちいただく場合があります。<br />
          ・ご返却送料のみお客様のご負担となります。<br />
          ・返却された貸出し品に破損や欠品が生じた場合は、修理代等をご負担いただく場合があります。<br />
          ・デモ機の使用にて生じたお客様への損害等は、いかなる場合でも弊社では責任を負いません。<br />
          <br />

          <div class="content-subtitle">■ お気軽にお問い合わせください</div>
          ・
          <router-link
            to="/contact"
            style="font-weight: bold; text-decoration: none; color: #4d4d4d;"
          >
            無料デモ機レンタルフォームへ
          </router-link>
          <br />
          ・お急ぎの方はお電話(
          <a href="tel:076-294-4440" style="color: #4d4d4d;"
            >TEL.076-294-4440</a
          >
          )にてお問い合わせください。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderBanner from '@/components/modules/HeaderBanner'
import ContentHeader from '@/components/modules/ContentHeader'
import Breadcrumb from '@/components/modules/Breadcrumb'

export default {
  components: {
    HeaderBanner,
    ContentHeader,
    Breadcrumb,
  },
  title: 'デモ機無料貸出し｜B-Call（ビーコール）',
  meta:
    'リモートリプライコール、リプライコール、リプライコールPC、エコチャイム、コココールファクトインコールのデモ機貸出しは、呼出しチャイム・呼出しシステムの専門店ビーコールにお任せください。',
  computed: {
    breadcrumbs: function() {
      return {
        data: [
          {
            name: '呼び出しベルのB-Call',
            path: 'https://b-call.jp/',
          },
          {
            name: 'デモ機貸出し方法',
            path: 'https://b-call.jp/rental',
          },
        ],
      }
    },
  },
}
</script>

<style scoped>
.news-contents {
  width: 90%;
  max-width: 1100px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Rental.vue